<style>

</style>

<Dialog show="{somethingWentWrong}" title="Something Went Wrong" close="{false}" buttons="{[]}">
  <p>Something went wrong.  We're sending you back in time...</p>
  <div class="center">
    <Spinner></Spinner>
  </div>
</Dialog>

<Dialog show="{noConnection}" title="No Connection" close="{false}" buttons="{[{text: 'Try Again', callback: 'tryAgain', disabled: false, }]}" on:tryAgain="{tryAgain}">
  <p>Weird, we can't reach HOT right now.  Sorry about that.</p>
  <p>We're working on it...</p>
</Dialog>

<Dialog show="{notLoggedIn}" title="Not Logged In" close="{false}" buttons="{[]}">
  <p>Looks like you're not logged in.</p>
  <p>Sending you to back to Log In.</p>
  <div class="center">
    <Spinner></Spinner>
  </div>
</Dialog>

<Dialog show="{errorShow}" title="{errorTitle}" close="{true}" buttons="{ [ { text: 'Close', callback: 'close', disabled: false } ] }" on:close="{ () => errorShow = false }">
  <p>{errorText}</p>
</Dialog>


<Loading show="{showLoading}" message="{loadingMessage}"></Loading>


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Loading from "../components/Loading.svelte";
import Dialog from "../components/Dialog.svelte";
import Spinner from "../components/Spinner.svelte";

let loadingMessage = "Loading";
let showLoading = false;

let somethingWentWrong = false;
let noConnection = false;
let notLoggedIn = false;

let errorTitle = "asdf";
let errorText = "fdsa";
let errorShow = false;

// set loading message
export const message = (m) => {
  loadingMessage = m;
  showLoading = true;
}


// hide loading message
export const hideMessage = () => {
  showLoading = false;
}


// used for uploading files and raw binary data
// body is an already created "new FormData();" that is 
// built before passing to this function
export const postBinary = async (url, body, loading) => {
  
  if (body == undefined) throw "Need at least some data to send.  Body is empty.";
  
  if (loading == undefined) {
    showLoading = true;
  } else {
    showLoading = loading;
  }
  
  let cookie = localStorage.getItem("cookie");
  let csrf = localStorage.getItem("csrf");
  
  body.append("cookie", cookie);
  body.append("csrf", csrf);
  
  // for(var pair of body.entries()) {
  //   console.log(pair[0]+ ': '+ pair[1]);
  // }
  
  try {
    
    const res = await fetch("https://routes.hot0.workers.dev/"+url, {
      method: "POST",
      body: body,
    });
    
    showLoading = false;
    
    if (res.status == 200) {
      
      const data = await res.text();
      // console.log("fetch.res.data:", data);
      return data;
      
    } else {
      
      console.log("there was a server error");
      console.log("res:", res);
      showLoading = false;
      
      if (res.status == 400) {
        somethingWentWrong = true;
        // setTimeout( () => {document.location = '/'}, 5000 );
      }
      
      if (res.status == 401) {
        // alert("Sorry, you're not authorized to do that. " + res.statusText + ". " + await res.text());
        // document.location = "/";
        notLoggedIn = true;
        setTimeout( () => {document.location = '/'}, 5000 );
      }
      
    }
    
  } catch (error) {
    
    showLoading = false;
    
    if (error == "TypeError: Failed to fetch") noConnection = true;
    
    throw error;
    
  }
  
}


// used for uploading standard json style data
export const post = async (url, body, loading) => {
  
  if (body == undefined) body = {};
  
  if (loading == undefined) {
    showLoading = true;
  } else {
    showLoading = loading;
  }
  
  let cookie = localStorage.getItem("cookie");
  let csrf = localStorage.getItem("csrf");
  
  body.cookie = cookie == null ? "" : cookie;
  body.csrf = csrf == null ? "" : csrf;
  
  // console.log("auth body:", body);
  
  try {
    
    const res = await fetch("https://routes.hot0.workers.dev/"+url, {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(body),
    });
    
    showLoading = false;
    
    if (res.status == 200) {
      
      const data = await res.text();
      // console.log("fetch.res.data:", data);
      return data;
      
    } else {
      
      console.log("there was a server error");
      console.log("res:", res);
      showLoading = false;
      
      if (res.status == 400) {
        somethingWentWrong = true;
        // setTimeout( () => {document.location = '/'}, 5000 );
      }
      
      if (res.status == 401) {
        // alert("Sorry, you're not authorized to do that. " + res.statusText + ". " + await res.text());
        // document.location = "/";
        notLoggedIn = true;
        setTimeout( () => {document.location = '/'}, 5000 );
      }
      
      if (res.status == 404) {
        errorShow = true;
        errorTitle = "Not Found";
        errorText = "Sorry, that resource wasn't found.";
      }
      
      
      // add if 404 to reload the app.  something has changed and the user hasn't
      // gotten the latest version of the web app.
      
    }
    
  } catch (error) {
    
    showLoading = false;
    
    if (error == "TypeError: Failed to fetch") noConnection = true;
    
    throw error;
    
  }
  
}


function tryAgain() {
  document.location = "/";
}


export const errorDialog = (title, text) => {
  showLoading = false;
  
  errorTitle = title;
  errorText = text;
  errorShow = true;
}



</script>